<template>
  <button
    data-testid="logout-button"
    class="side__menu__settings__item flex w-full cursor-pointer flex-row items-center border-y border-[#B8CBEC] text-left focus-visible:ring-inset"
    type="button"
    :aria-label="$t('menu.logout')"
    @click="logout"
  >
    <AppIcon
      name="custom:topbar/logout"
      :width="20"
      alt=""
      aria-hidden="true"
    />
    <p
      :class="{ hidden: !hovered }"
      class="min-w-50 leading-none text-primary-600"
    >
      {{ $t('menu.logout') }}
    </p>
  </button>
</template>

<script>
export default {
  props: {
    hovered: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    logout() {
      localStorage.removeItem('document-translator-info')
      this.$keycloak.logout({
        locale: this.$i18n.locale,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.side__menu__settings__item {
  color: var(--color-primary-600);
  background: var(--color-neutral-50);
  padding: 1.1rem 1.8rem;
  min-height: 2.75rem;
  line-height: 1;
  font-family: $mainFont;
  font-size: 1rem;
  gap: 1.25rem;
  transition: background 0.3s ease;

  &:hover,
  &:focus-visible {
    background: var(--color-primary-200);
    transition: 0.8s;
  }
}
</style>
